var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreePointers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 128,
    viewBox: "0 0 900 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M894.596 12.9691C897.282 12.9691 899.46 10.7917 899.46 8.10571C899.46 5.41973 897.282 3.24231 894.596 3.24231C891.91 3.24231 889.733 5.41973 889.733 8.10571C889.733 10.7917 891.91 12.9691 894.596 12.9691Z",
    stroke: "#677788",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M884.329 7.56527C884.329 7.56527 770.039 4.86338 711.408 110.237",
    stroke: "#677788",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M705.464 123.747C708.15 123.747 710.327 121.569 710.327 118.883C710.327 116.197 708.15 114.02 705.464 114.02C702.778 114.02 700.6 116.197 700.6 118.883C700.6 121.569 702.778 123.747 705.464 123.747Z",
    stroke: "#677788",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67395 12.9691C8.35993 12.9691 10.5374 10.7917 10.5374 8.10571C10.5374 5.41973 8.35993 3.24231 5.67395 3.24231C2.98797 3.24231 0.810547 5.41973 0.810547 8.10571C0.810547 10.7917 2.98797 12.9691 5.67395 12.9691Z",
    stroke: "#677788",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2113 7.56527C16.2113 7.56527 130.501 4.86338 189.132 110.237",
    stroke: "#677788",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.806 123.747C197.492 123.747 199.67 121.569 199.67 118.883C199.67 116.197 197.492 114.02 194.806 114.02C192.12 114.02 189.943 116.197 189.943 118.883C189.943 121.569 192.12 123.747 194.806 123.747Z",
    stroke: "#677788",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M453.918 12.9691C456.604 12.9691 458.781 10.7917 458.781 8.10571C458.781 5.41973 456.604 3.24231 453.918 3.24231C451.232 3.24231 449.054 5.41973 449.054 8.10571C449.054 10.7917 451.232 12.9691 453.918 12.9691Z",
    stroke: "#677788",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M453.918 18.1027V108.886",
    stroke: "#677788",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M453.918 123.747C456.604 123.747 458.781 121.569 458.781 118.883C458.781 116.197 456.604 114.02 453.918 114.02C451.232 114.02 449.054 116.197 449.054 118.883C449.054 121.569 451.232 123.747 453.918 123.747Z",
    stroke: "#677788",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreePointers);
export default __webpack_public_path__ + "static/media/three-pointers.f29e3c4faf9e6b50a4e66919765e842e.svg";
export { ForwardRef as ReactComponent };